<template>
  <Portal>
    <Modal
      class="variation-modal"
      data-testid="variation-modal"
      :is-open="isOpen"
      @close="$emit('close')"
    >
      <HeadingDisplay
        size="small"
        title="Você já editou seus limites hoje. Deseja continuar?"
        :subtitle="subtitle"
      />
      <ContentDisplay class="variation-modal__content">
        <template #content-block-1>
          <HeadingDisplay
            size="small"
            title="Posição"
            :subtitle="marginAllocation.updatedAt"
          />
          <ListDisplay
            class="variation-modal__content-item"
            title="Saldo day trade"
            :value="marginAllocation.balance.formatted"
          />
          <ListDisplay
            class="variation-modal__content-item"
            title="Variação"
            :value="marginAllocation.variation.formatted"
            :value-color="variationColor"
          />
        </template>
      </ContentDisplay>
      <template #buttonContainer>
        <ButtonContainer>
          <template #button-primary>
            <ButtonPrimary
              size="large"
              label="Continuar"
              data-testid="confirm-variation"
              @click="$emit('continue')"
            />
          </template>
          <template #button-secondary>
            <ButtonSecondary
              size="large"
              label="Voltar"
              @click="$emit('close')"
            />
          </template>
        </ButtonContainer>
      </template>
    </Modal>
  </Portal>
</template>

<script lang="ts" setup>
import { computed, inject, Ref } from 'vue';

import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import {
  Modal,
  HeadingDisplay,
  ContentDisplay,
  ListDisplay,
  ButtonContainer,
  ButtonPrimary,
  ButtonSecondary
} from '@warrenbrasil/nebraska-web';
import { Portal } from '@/modules/common/components/Portal';

import { IMarginAllocationV2 } from '@/modules/trade/services/margin-allocation';

interface Props {
  isOpen: boolean;
}
defineProps<Props>();

const marginAllocation = inject('marginAllocation') as Ref<IMarginAllocationV2>;

const subtitle = computed(() => {
  return marginAllocation.value.variation.value < 0
    ? 'Prejuízos influenciam na realocação de limites.'
    : '';
});

const variationColor = computed(() => {
  const colorMapper: { [key: string]: NebraskaColors } = {
    positive: NebraskaColors.monetaryPositive,
    negative: NebraskaColors.monetaryNegative,
    primary: NebraskaColors.elementPrimary
  };

  return colorMapper[marginAllocation.value.variation.color];
});
</script>

<style lang="less" scoped>
.variation-modal {
  :deep(.base-modal--wrapper) {
    width: 592px;
    max-width: 592px;
  }

  :deep(.modal-content) {
    text-align: left;
    padding: 0 @size-spacing-x1000 @size-spacing-x1000;
  }

  &__content {
    width: 100%;
    margin-top: @size-spacing-x600;
  }

  &__content-item {
    margin-top: @size-spacing-x350;

    &:first-of-type {
      margin-top: @size-spacing-x500;
    }
  }
}
</style>
